import { Component, Vue } from 'vue-property-decorator';
import categorySecondLevelModule from '@/store/modules/category-second-level.module'
import { CategorySecondLevel } from '@/shared/dtos/category-second-level';
import DxDataGrid, { DxLookup, DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';
import categoryFirstLevelModule from '@/store/modules/category-first-level.module';
import { itiMessageService } from '@/iti-core-vue';



@Component({
    components: {
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser,
        DxLookup
    },
})

export default class CategorySecondLevelLista extends Vue {

    public pageSize: number = 15;
    public maxWidth: number = 500;
    public addHidden = true;
    public loading = false;
    public search = '';
    public categorySecondLevelCode: CategorySecondLevel = new CategorySecondLevel();

    public get categorySecondLevelList() {
        return categorySecondLevelModule.categories;
    }

    public get categoryFirstLevelList() {
        return categoryFirstLevelModule.categories;
    }

    public get columns() {
        return [
            { dataField: 'id', allowEditing: false },
            { dataField: 'code', caption: this.$tc('maestro-configuracion.codigo'), allowEditing: true },
            { dataField: 'description', caption: this.$tc('maestro-configuracion.descripcion'), allowEditing: true },
            {
                dataField: 'categoryFirstLevel.id', caption: this.$tc('maestro-configuracion.categoria-primer-nivel'),
                lookup: {
                    dataSource: this.categoryFirstLevelList,
                    valueExpr: 'id',
                    displayExpr: 'code'
                }
            },
            { dataField: 'externalID', caption: this.$tc('maestro-configuracion.externalID'), allowEditing: false },
        ]
    }

    public async mounted() {
        await categorySecondLevelModule.getCategoriesSecondLevel();
        await categoryFirstLevelModule.getCategoriesFirstLevel();
    }

    public async rowInserted(e: any) {
        if (e.data.categoryFirstLevel == undefined || e.data.categoryFirstLevel == null || e.data.categoryFirstLevel.id < 1) {
            await categorySecondLevelModule.getCategoriesSecondLevel();
            itiMessageService.toast(this.$tc('mensajes.error-categoria-padre-vacia'), 'error', 2000);
        }
        else
            categorySecondLevelModule.insertarCategorySecondLevel(e.data);
    }

    public async rowUpdated(e: any) {
        if (e.data.categoryFirstLevel == undefined || e.data.categoryFirstLevel == null || e.data.categoryFirstLevel.id < 1) {
            await categorySecondLevelModule.getCategoriesSecondLevel();
            itiMessageService.toast(this.$tc('mensajes.error-categoria-padre-vacia'), 'error', 2000);
        }
        else
            categorySecondLevelModule.modificarCategorySecondLevel(e.data);
    }

    public rowRemoved(e: any) {
        categorySecondLevelModule.eliminarCategorySecondLevel(e.key);
    }

    public initNewRow(e: any) {
        e.data.id = 0;
    }
}